/* TLR hot list rail — assets/tlr-hot-list.js */
(function () {
  const mqMobile = window.matchMedia('(max-width: 749px)');

  // Merchant toggled the rail off for phones. A display:none rail reports
  // scrollWidth and clientWidth of 0, which reads as "nothing to scroll yet"
  // and would prime a Section Rendering fetch on every mobile page load for a
  // section nobody can see. Bail before binding anything.
  const hiddenHere = scope => scope.classList.contains('is-hide-m') && mqMobile.matches;

  function setup(scope) {
    if (hiddenHere(scope)) return;

    const rail = scope.querySelector('[data-tlr-rail]');
    if (!rail || rail.dataset.tlrRailBound) return;
    rail.dataset.tlrRailBound = '1';

    const prev = scope.querySelector('[data-tlr-rail-prev]');
    const next = scope.querySelector('[data-tlr-rail-next]');
    const step = () => {
      const card = rail.querySelector('.tlr-hot__card');
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 18;
      return card ? (card.getBoundingClientRect().width + gap) * 2 : rail.clientWidth * 0.8;
    };

    const sync = () => {
      if (!prev || !next) return;
      const max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
    };

    prev && prev.addEventListener('click', () => { stop(); rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next && next.addEventListener('click', () => { stop(); rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    /* ---- load more (Section Rendering API) ------------------------------- */
    // The section is paginated by "products to show"; each fetch pulls the next
    // page of the same section and appends its cards into the snap rail.
    const maxProducts = parseInt(scope.dataset.maxProducts, 10) || 0;
    let page = 1;
    let loading = false;

    const loadMore = () => {
      if (loading || rail.querySelectorAll('.tlr-hot__card').length >= maxProducts) return;
      loading = true;
      fetch(window.location.pathname + '?section_id=' + scope.dataset.sectionId + '&page=' + (page + 1))
        .then(r => r.text())
        .then(html => {
          const more = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelectorAll('[data-tlr-rail] .tlr-hot__card');
          if (!more.length) return; // collection exhausted — stay locked
          rail.append(...more);
          page += 1;
          loading = false;
          sync();
        })
        .catch(() => {}); // leave loading set so a failed fetch never retry-loops
    };

    rail.addEventListener('scroll', () => {
      if (rail.scrollLeft + rail.clientWidth > rail.scrollWidth * 0.7) loadMore();
    }, { passive: true });
    // Nothing to scroll yet on a wide screen: prime the next page so the arrows
    // work. The clientWidth check keeps a zero-width rail — hidden by CSS, or
    // in a collapsed parent — from reading as "empty" and fetching for nothing.
    if (rail.clientWidth && rail.scrollWidth <= rail.clientWidth + 4) loadMore();

    /* ---- auto-scroll ---------------------------------------------------- */
    let timer = null;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const enabled = () => rail.hasAttribute('data-tlr-autoplay') && !reduced.matches;
    const interval = () => parseInt(rail.dataset.tlrInterval, 10) || 4000;
    const loops = () => rail.dataset.tlrLoop !== 'false';

    // A single card per tick reads better than the two-card jump the arrows use.
    const autoStep = () => {
      const card = rail.querySelector('.tlr-hot__card');
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 18;
      return card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.4;
    };

    const advance = () => {
      const max = rail.scrollWidth - rail.clientWidth - 2;
      if (rail.scrollLeft >= max) {
        if (!loops()) return stop();
        rail.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        rail.scrollBy({ left: autoStep(), behavior: 'smooth' });
      }
    };

    function start() {
      // Rotating into the hidden breakpoint must not leave a timer ticking
      // against a rail with no layout box.
      if (timer || !enabled() || hiddenHere(scope)) return;
      timer = setInterval(advance, interval());
    }
    function stop() {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
    }
    // Pause on any intent to interact, resume once it passes.
    ['mouseenter', 'focusin', 'touchstart', 'pointerdown'].forEach(e =>
      rail.addEventListener(e, stop, { passive: true }));
    ['mouseleave', 'focusout'].forEach(e =>
      rail.addEventListener(e, start, { passive: true }));
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    reduced.addEventListener('change', () => (reduced.matches ? stop() : start()));
    // Crossing 750px can hide or reveal the rail; settle the timer either way.
    onBreakpointChange(() => (hiddenHere(scope) ? stop() : start()));

    // Only run while the rail is actually on screen.
    if (enabled() && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        entries => entries.forEach(en => (en.isIntersecting ? start() : stop())),
        { threshold: 0.25 }
      ).observe(rail);
    } else {
      start();
    }

    // The editor swaps the section's DOM on every settings change; without this
    // the old interval keeps firing against a detached rail.
    rail._tlrStopAuto = stop;
  }

  function onBreakpointChange(fn) {
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', fn);
    else if (mqMobile.addListener) mqMobile.addListener(fn);
  }

  const init = () => document.querySelectorAll('.tlr-hot').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('[data-tlr-rail]').forEach(r => r._tlrStopAuto && r._tlrStopAuto());
  });
  // An iPhone in landscape is 844px wide, so a rail skipped on load can become
  // visible on rotation. setup() is idempotent — bound rails return early.
  onBreakpointChange(init);
})();